<template>
  <div>
    <ViewSelector :views="views" :activeViewName="activeViewName" @setActiveViewName="setActiveViewName" />
    <div class="wrapper">
      <ChartSelector
        :activeViewName="activeViewName"
        :activeChartContentName="activeChartContentName"
        :activePerformanceData="activePerformanceData"
        @setActiveChartContentName="setActiveChartContentName"
      />
      <RateAndTotalChart :rateTotalData="activeRateTotalData" :rateTotalAttr="activeRateTotalAttr" />
    </div>
  </div>
</template>

<script>
import RateAndTotalChart from "@/components/shared/RateAndTotalChart/Index";
import ViewSelector from "./ViewSelector/Index";
import ChartSelector from "./ChartSelector/Index";
import { PERFORMANCE_DEFINITION } from "@/misc/desktopCharts";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    ViewSelector,
    ChartSelector,
    RateAndTotalChart,
  },
  data() {
    return {
      views: PERFORMANCE_DEFINITION,
    };
  },
  computed: {
    ...mapGetters({
      activeViewName: "performance/getActiveViewName",
      activeChartContentName: "performance/getActiveChartContentName",
      performanceData: "performance/getPerformanceData",
    }),
    activePerformanceData() {
      return this.performanceData[this.activeViewName];
    },
    activeRateTotalData() {
      return this.activePerformanceData[this.activeChartContentName];
    },
    activeRateTotalAttr() {
      const activeViewName = this.activeViewName;
      const activeChartContentName = this.activeChartContentName;
      return this.views
        .find((view) => view.name === activeViewName)
        .content.find((content) => content.name === activeChartContentName);
    },
  },
  methods: {
    ...mapMutations({
      setActiveViewName: "performance/setActiveViewName",
      setActiveChartContentName: "performance/setActiveChartContentName",
    }),
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin-top: -1px;
  padding: 16px;
  border: $border-light;
  background-color: $white;
}
</style>
